import { useState } from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "es", label: "Español" },
  { code: "pt", label: "Português" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const current =
    languages.find((l) => l.code === (i18n.language || "en").split("-")[0]) ||
    languages[0];

  const handleChange = (code: string) => {
    i18n.changeLanguage(code);
    localStorage.setItem("i18nextLng", code);
    document.documentElement.lang = code;
    setOpen(false);
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 rounded-md border border-background-300/60 bg-background-50 px-3 py-2 text-sm font-medium text-foreground-900 transition hover:bg-background-100 cursor-pointer whitespace-nowrap"
        aria-label="Change language"
      >
        <i className="ri-global-line text-base"></i>
        <span>{current.label}</span>
        <i className={`ri-arrow-down-s-line text-sm transition-transform ${open ? "rotate-180" : ""}`}></i>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-20" onClick={() => setOpen(false)}></div>
          <div className="absolute right-0 z-30 mt-2 w-44 overflow-hidden rounded-lg border border-background-200 bg-background-50 py-1">
            {languages.map((lang) => (
              <button
                key={lang.code}
                type="button"
                onClick={() => handleChange(lang.code)}
                className={`flex w-full items-center justify-between px-3 py-2 text-sm transition hover:bg-background-100 cursor-pointer whitespace-nowrap ${
                  lang.code === current.code ? "text-primary-700 font-semibold" : "text-foreground-700"
                }`}
              >
                <span>{lang.label}</span>
                {lang.code === current.code && <i className="ri-check-line"></i>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}